import type { SwivuFile } from "@/react/components/entityViews/files/types/swivuFile";
import { getFileExtension } from "@/modern/utils";

/** Video/audio often share API `fileType: "image"` with photos. */
const VIDEO_EXTENSIONS = new Set([
  "mp4",
  "avi",
  "mov",
  "wmv",
  "flv",
  "mkv",
  "webm",
  "m4v",
]);

const AUDIO_EXTENSIONS = new Set([
  "mp3",
  "wav",
  "ogg",
  "m4a",
  "flac",
  "aac",
  "wma",
]);

/** Still images only — excludes video/audio that share media `fileType`. */
export const isImageFileTyped = (file: SwivuFile | null): file is SwivuFile => {
  if (!file || file.fileType !== "image") return false;
  const ext = getFileExtension(file.name);
  return !VIDEO_EXTENSIONS.has(ext) && !AUDIO_EXTENSIONS.has(ext);
};

export const isVideoFileTyped = (file: SwivuFile | null): file is SwivuFile => {
  if (!file || file.fileType !== "image") return false;
  return VIDEO_EXTENSIONS.has(getFileExtension(file.name));
};

export const isAudioFileTyped = (file: SwivuFile | null): file is SwivuFile => {
  if (!file || file.fileType !== "image") return false;
  return AUDIO_EXTENSIONS.has(getFileExtension(file.name));
};
